<div class="app-main-menu" fxLayout="row">
  <img mat-icon class="app-logo" src="assets/logo.svg" />
  <div class="app-menu-container">
    <div class="main-text">DESIGN</div>
    <small class="app-version">v{{version}}</small>
  </div>
</div>
